<!--表格组件 -->
<template>
  <section class="ces-table-page">
    <!-- 表格操作按钮 -->
    <!-- 数据表格 -->
    <section class="ces-table">
      <el-table
        :row-key="(row)=>{return row.userId}"
        :data="tableData"
        :size="size"
        :max-height="maxHeight"
        :border="isBorder"
        :reviewId="reviewId"
        :activeTab="activeTab"
        @select="select"
        @select-all="selectAll"
        v-loading="loading"
        @sort-change="changeSort"
        @row-dblclick="(row, column, event)=>{rowDblClick(row, column, event,editList)}"
        fit
        style="width:100%"
        ref="cesTable"
        :header-cell-style="{'background-color': '#007AE1','height':'45px','color':'#fff'}"
        :row-class-name="tableRowClassName"
        :row-style="selectedstyle"
        :cell-class-name="rowClass"
        :span-method="spanMethod"
        :show-summary="summary"
        :summary-method="getSummaries"
      >
        <el-table-column
          :selectable="isSelectable?selecteable:notselecteable"
          v-if="isSelection"
          type="selection"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column v-if="isIndex" type="index" :label="indexLabel" align="center" width="80"></el-table-column>
        <!-- 数据栏 -->
        <el-table-column
          v-for="item in tableCols"
          v-show="item.show === true"
          :key="item.id"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :align="item.align"
          :fixed="item.type=='Button'||item.type=='ButtonReview'?'right':null"
          :render-header="item.require?renderHeader:null"
          :sortable="item.sortable"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!-- 按钮 -->
            <span v-if="item.type==='Button'">
              <span>
                <span
                  class="operation"
                  :class="[(btn.formatterClass && btn.formatterClass(scope.row,btn.prop,scope.row[btn.prop])) || btn.itemClass,
                  scope.row.question_status==0&&btn.handleThis=='edit'?'canotHandle':'', scope.row.isAdvanced==0?btn.itemClass1:'']"
                  v-for="(btn,index) in item.btnList"
                  :key="index"
                  @click="btn.handle(scope.row,scope.$index)"
                  v-auth="btn.auth"
                >
                  <span>{{(btn.formatter && btn.formatter(scope.row,btn.prop,scope.row[btn.prop])) || btn.label}}</span>
                </span>
              </span>
            </span>
            <span v-else-if="item.type==='Button-btn'">
              <el-button
                v-for="(btn,index) in item.btnList"
                :key="scope.$index+''+index"
                size="mini"
                :type="btn.type"
                :icon="btn.icon"
                :plain="btn.plain"
                @click="btn.handle(scope.row,scope.$index)"
                :disabled="btn.disabled?btn.disabled(scope.row,btn.prop,scope.row[btn.prop]):false"
                v-auth="btn.auth"
              >{{(btn.formatter && btn.formatter(scope.row,btn.prop,scope.row[btn.prop])) || btn.label}}</el-button>
            </span>
            <!-- 非按钮 -->
            <div v-else>
              <!-- 编辑 -->
              <div class="edit-input" v-if="item.isEdit">
                <el-input
                  v-model="tableData[scope.$index][item.prop]"
                  placeholder="值"
                  style="width: 100%"
                  @blur="blurEdit($event)"
                  size="small"
                ></el-input>
              </div>
              <el-popover trigger="hover" placement="top" v-if="item.type=='phone'">
                <p>联系方式: {{ scope.row[item.type] }}</p>
                <div slot="reference" class="name-wrapper">
                  <span
                    class="read"
                  >{{(item.formatter && item.formatter(scope.row,item.prop,scope.row[item.prop])) || scope.row[item.prop] || '--'}}</span>
                </div>
              </el-popover>
              <!-- 审核状态 -->
              <span
                class="reviewCell"
                v-if="item.type=='review'"
              ><i :class="scope.row[item.prop]=='待审核'?'el-icon-time':scope.row[item.prop]=='审核通过'?'el-icon-circle-check':'el-icon-warning-outline'"
              :style="{color:scope.row[item.prop]=='待审核'?'#67C23A':scope.row[item.prop]=='审核通过'?'#409EFF':'#F56C6C',fontSize:'16px',marginRight:'3px'}"></i>
              {{(item.formatter && item.formatter(scope.row,item.prop,scope.row[item.prop])) || scope.row[item.prop] || '--'}}</span>
              <!-- 普通单元格 -->
              <!-- 文本超出两行省略号显示 -->
              <span
                v-else
                style="display: inherit;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{(item.formatter && item.formatter(scope.row,item.prop,scope.row[item.prop])) || scope.row[item.prop] || '--'}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 分页 -->
    <section class="ces-pagination" v-if="isPagination">
      <el-pagination
        background
        style="display: flex;justify-content: center;height: 100%;align-items: center;"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.size"
        layout="total, sizes,prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </section>
  </section>
</template>

<script>
import { addClass, removeClass } from '../../utils';
var elementResizeDetectorMaker = require('element-resize-detector');
export default {
  name: 'tablePage',
  props: {
    // 表格型号：mini,medium,small
    size: { type: String, default: 'medium' },
    isBorder: { type: Boolean, default: true },
    summary: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // 表格操作
    isHandle: { type: Boolean, default: false },
    reviewId: { type: Number, default: 0 },
    activeTab: {type: String, default: '0'},
    // 表格数据
    tableData: { type: Array, default: () => [] },
    getSummaries: { type: Function, default: () => {} },
    // 表格列配置
    tableCols: { type: Array, default: () => [] },
    // 是否显示表格复选框
    isSelection: { type: Boolean, default: false },
    // 是否显示表格索引
    isIndex: { type: Boolean, default: false },
    // 是否可选
    isSelectable: { type: String, default: '' },
    indexLabel: { type: String, default: '序号' },
    // 是否显示分页
    isPagination: { type: Boolean, default: true },
    // 分页数据
    pagination: {
      type: Object
    },
    // 可行内编辑字段
    editList: {
      type: Array,
      default: () => []
    },
    // 表格的className
    // rowClassName: {
    //   type: Function,
    //   default: () => {}
    // },
    // 单元格的样式
    rowClass: {
      type: Function,
      default: () => {}
    },
    // 合并行列方法
    spanMethod: {
      type: Function,
      default: () => {}
    },
    // 多选清空
    clearSelection: {
      type: Boolean, default: false
    },
    showMaxHeight: {
      type: Boolean, default: false
    }
  },
  data () {
    return {
      maxHeight: 0,
      getIndex: null // 被点击行下标
      // currentRow: null // 被点击行数据
    }
  },
  watch: {
    clearSelection (a, b) {
      console.log(a, b, '---------');
      if (b) {
        this.$refs.cesTable.clearSelection();
      }
    }
  },
  methods: {
    blurEdit (event) {
      console.log(event)
      removeClass(event.path[3], 'edit-col')
    },
    // 行点击
    rowDblClick (row, column, event, editList) {
      console.log(row, column, event, editList);
      if (editList.indexOf(column.property) !== '-1') {
        addClass(event.target, 'edit-col')
      }
    },
    // 表格勾选
    select (rows, row) {
      console.log(rows);
      this.$emit('update:select', rows)
    },
    selecteable (row, index) {
      // 虚拟实验室多选禁选
      if (this.isSelectable === 'virtual') {
        console.log(this.tableData[index].status)
        if (this.tableData[index].status === '1') { // 0-未入库，1-已入库
          return false
        } else {
          return true
        }
        // 基地管理员一览多选禁选
      } else {
        if (this.tableData[index].roleMouldVOList.length > 0) {
          return false
        } else {
          return true
        }
      }
    },
    notselecteable () {
      return true
    },
    // 全选
    selectAll (rows) {
      console.log(rows);
      this.$emit('update:select', rows)
    },
    handleCurrentChange (val) {
      this.rowClick('') // 跨页清空选中状态
      this.$emit('update:pagination', { ...this.pagination, page: val })
    },
    handleSizeChange (val) {
      this.rowClick('') // 跨页清空选中状态
      this.$emit('update:pagination', { ...this.pagination, rows: val })
    },
    changeSort (val) {
      this.$emit('changeSort', val)
    },
    renderHeader (h, obj) {
      return h('span', { class: 'ces-table-require' }, obj.column.label);
    },
    // 设置行对象(row)的样式(style)
    selectedstyle ({ row, rowIndex }) {
      if (this.getIndex === rowIndex) {
        return {
          'background-color': 'oldlace'
        };
      }
    },
    // 为行对象(row)设置index属性
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 行点击事件,这里获取到的行对象(row)是没有index属性的
    rowClick (row) {
      console.log(row.index, 'index')
      this.getIndex = row.index;
      // this.currentRow = row
    }
  },
  mounted () {
    var erd = elementResizeDetectorMaker();
    let _this = this
    this.$nextTick(() => {
      this.maxHeight = document.body.offsetHeight - 240;
      erd.listenTo(this.$refs.cesTable.$refs.bodyWrapper.firstChild, function (element) {
        if ((element.clientWidth > _this.$refs.cesTable.$refs.bodyWrapper.clientWidth) && _this.$refs.cesTable.$refs.rightFixedWrapper) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.bottom = '10px'
        }
        if ((element.clientHeight >= _this.maxHeight) && _this.$refs.cesTable.$refs.rightFixedWrapper) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.right = '10px'
        } else {
          if (_this.$refs.cesTable.$refs.rightFixedWrapper) _this.$refs.cesTable.$refs.rightFixedWrapper.style.right = '0'
        }
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.ces-pagination
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #007ae1;
  border-radius: 50%;
  /* border:2px solid #cccccc; */
  color: #fff;
  box-shadow: 0 0 0 0.05rem rgba(0, 122, 225, 0.15);
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ebedf5;
  border-radius: 5px;
}

.ces-table .el-table__fixed-body-wrapper {
  height: calc(100% - 43px) !important;
}
/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}
/deep/ .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #fff;
}
/deep/ .el-table--mini, .el-table--small, .el-table__expand-icon{
  font-size: 14px;
  font-weight: 500;
}
/deep/ .el-checkbox__inner{
  border: 2px solid #DCDFE6;
  width: 18px;
  height: 18px;
}
/deep/ .el-table .cell.el-tooltip{
  white-space: normal;
}
.el-table__row.edit-row {
  height: 50px;
}
.el-table .redClass {
  color: red;
}
.btn {
  display: inline-block;
  background: #4093ff;
  color: #fff;
  padding: 1px 8px;
  border-radius: 3px;
  margin: 5px;
}
.ces-table-require::before {
  content: "*";
  color: red;
}
.reviewCell{
  display: flex;
  align-items: center;
  justify-content: center;
}
.operation {
  cursor: pointer;
  padding: 0 5px;
}
.ces-pagination {
  margin-top: 20px;
}
.ces-table-page {
  margin-left: 20px;
}
.operation.green {
  color: #95d1a3;
}
.operation.red {
  color: #ff0000;
}
.operation.blue {
  color: #409eff;
}
.operation.orange {
  color: #f56c6c;
}
.operation.btnGrey {
  color: #cccccc;
}
.edit-input {
  display: none;
}
.edit-col .edit-input {
  display: block;
}
.edit-col .read {
  display: none;
}
.content-overflow{
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  // display:-webkit-box;
  // -webkit-line-clamp:2; // 元素几行显示
  // -webkit-box-orient:vertical;
}
.redClass {
  color: red;
  background: #000;
}

.audit_btn {
  margin-left: 5px;
  padding: 1px 6px;
  border-radius: 2px;
  background: rgb(0, 122, 225);
  color: white;
}
.operation.canotHandle{
  color: #ccc;
  cursor: not-allowed;
}
.isCollect {
  background-color: #0f85e8;
  color: #fff;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 12px;
}
.cancelCollect{
  color: #999;
}
.goods{
  display: inline-block;
  width: 25px;
  height: 25px;
  background-image: url('../../../static/images/goods.png');
  background-size: 100%;
  vertical-align: bottom;
}
</style>
<style>
.el-table .warning-row {
  background: oldlace;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tablePage.vue